(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const variantTitle = variant.title.toLowerCase();
  const gallery = document.querySelector('product-media-gallery');
  if (!gallery) return;

  const slides = gallery.querySelectorAll('.splide__slide');
  slides.forEach(function (slide) {
    const img = slide.querySelector('img');
    const alt = (img?.getAttribute('alt') || '').toLowerCase();
    const matches = alt === '' || alt.includes(variantTitle);
    slide.style.display = matches ? '' : 'none';
  });

  window.dispatchEvent(new Event('resize'));
});
  } catch(e) { console.error(e); }
})();

})();
